/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleMinus = createReactComponent("circle-minus", "IconCircleMinus", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 12l6 0", key: "svg-1" }]
]);

export { IconCircleMinus as default };
//# sourceMappingURL=IconCircleMinus.js.map
